import React from 'react';
import {useStyles} from './helper';
import { useDispatch } from 'react-redux';
import {setUpdatePaymentSystem} from '../../store/thunk/setUpdatePaymentSystem';

const PaymentItem = ({item}) => {
    const {label, status, id} = item;
    const dispatch = useDispatch();
    const [statusPayment, setStatusPayment] = React.useState(status);

    const classes = useStyles({status: statusPayment});
  
    return (
        <div className={classes.root}>
            <div className={classes.wrap}>
                <span className={classes.icon}></span>
                <span>{label}</span>
                <div className={classes.wrapBtn}>
                    <span 
                        className={classes.btn}
                        onClick={() => {
                            setStatusPayment(!statusPayment);
                            dispatch(setUpdatePaymentSystem({
                                id,
                                status: !statusPayment
                            }))
                        }}
                    >{statusPayment ? 'Отключить' : 'Включить'}</span>
                </div>
            </div>
        </div>
    )
}

export default PaymentItem